import http from './http';

export const getAllBooks   =   ()   => http.get('api/books');
export const getFirstBooks =  ()    => http.get('api/books/first');
export const getBookByType = (type) => http.get(`api/books/type/${type}`);
export const getBookBySlug = (slug) => http.get(`/title/${slug}`);
export const postBook      = (data) => http.post('api/livros/disabled/QGE1ZWRpdG9yYQ==', data);



// WEBPACK FOOTER //
// ./src/services/Book.js